import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {GGGameAssets} from "./GGGameAssets";
import {GoldenGoblins} from "./GoldenGoblins";
import {GGGameMode} from "./gamemode/GGGameMode";
import {GGGameModuleConfig} from "./GGGameModuleConfig";
import {GGSoundConfig} from "./GGSoundConfig";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {GGGameConfig} from "./GGGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GGReelSymbol} from "./symbols/GGReelSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GGReelController} from "./reel/GGReelController";


export class EvilGoblinsPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    onPlayBonusInGame(data:any):void {
        const reels: string[][] = data.evaluatedArea;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels[i].length; j++) {
                const newSymName:string = reels[i][j];
                const newSym:StateReelSymbol = (<GGReelController>Reels.getReel(i)).addTransformedSymbol(newSymName);
                (<GGReelController>Reels.getReel(i)).removeTransformedSymbol(newSym, j);
            }
        }

        for(let i:number = 0; i < GGGameConfig.instance.REELS_NUM; i++) {
            (<GGReelController>Reels.getReel(i)).updateSizeAS(data.gameAreaSize);
        }

        EventHandler.dispatchEvent(new GameEvent("STATING_BONUS_FROM_AS"));
        SlotGame.keypad.setWin(data.accumulatedRoundWin, true);
        setTimeout(() => {
            EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_RECEIVED, data));
            EventHandler.dispatchEvent(new GameEvent(ScreenEvent.GAME_START));
        }, 500);
    }



    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "GoldenGoblins",
            hasActionSpin: true,
            graphics: {backgroundTextureName: GGGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {

                if (response.mode == GGGameMode.NORMAL ){
                    this.lastFeature = "";
                }

                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: response.totalAvalancheRoundWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            GoldenGoblins.sound.playEffect(GGSoundConfig.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            GoldenGoblins.sound.playEffect(GGSoundConfig.AS_WIN_BIG);
        }
    }

    private isBigWin(response: any): boolean {
        let win: number = response.totalAvalancheRoundWinnings;

        if (response.wasFeatureBuy) {
            const betPrice = GGGameModuleConfig.featurePrice.getBuyFeaturePriceAS(response);
            let winRatio: number = win / betPrice;
            return winRatio >= 1;
        }

        let winRatio: number = win / response.playedBetValue;
        return winRatio >= 15;
    }

    private getSpinWin(response: any, bet: number, prevData: any): number {
        return response.totalAvalancheRoundWinnings;
    }

    private isFreeSpinTriggered(response: any): boolean {
        let isFs = response.freespinTriggeredThisSpin;
        const isDoubleBombStart = response.doubleBombSpins === 2 && response.mode === GGGameMode.DOUBLE_BOMB;

        const activeFeature = SlotGame.api.betFeatureController.getActiveBetFeature();
        if (activeFeature?.name === "FREESPIN_LEVEL6"){
            isFs = false;
        }
        return isFs || isDoubleBombStart;
    }

    public isLegalStopOnBonusMode(data:IResponseData):boolean {
        return [GGGameMode.FREESPIN, GGGameMode.FREESPIN_SUPER, GGGameMode.DOUBLE_BOMB].indexOf(data.nextMode) > -1;
    }



    private lastFeature = "";
    private getFeatureName(response: any): string {
        if (response.mode == GGGameMode.FREESPIN || response.nextMode == GGGameMode.FREESPIN){

            if (response.bombGuarantee){
                this.lastFeature = "EXPLOSIVE FRESH MEAT SPINS";
            } else {
                this.lastFeature = "FRESH MEAT SPINS";
            }
        }

        if (response.mode == GGGameMode.FREESPIN_SUPER || response.nextMode == GGGameMode.FREESPIN_SUPER) {
            if (response.bombGuarantee){
                this.lastFeature = "EXPLOSIVE GOBLINS FEAST SPINS";
            } else {
                this.lastFeature = "GOBLINS FEAST SPINS";
            }
        }


        if (response.mode == GGGameMode.DOUBLE_BOMB || response.nextMode == GGGameMode.DOUBLE_BOMB){
            this.lastFeature = "XBOMB X2";
        }

        return this.lastFeature;
    }

    private isRoundComplete(response: any): boolean {
        const notNextAvalanche = [GGGameMode.NORMAL, GGGameMode.FREESPIN, GGGameMode.FREESPIN_SUPER, GGGameMode.DOUBLE_BOMB].indexOf(response.nextMode) > -1;
        const isDoubleBomb = response.doubleBombSpins === 2 && response.mode === GGGameMode.DOUBLE_BOMB;
        return notNextAvalanche || isDoubleBomb;
    }

    private isBonusEnd(response: any): boolean {
        return ((response.nextMode === GGGameMode.NORMAL) && (response.mode === GGGameMode.FREESPIN || response.mode === GGGameMode.FREESPIN_SUPER)) || (response.doubleBombSpins === 0 && response.nextMode === GGGameMode.NORMAL);
    }


}